
import {
   EXPERT_MULTI_KEYWORD_CHANGE
 } from '../../actions/types';
 
 const initialState = {
    multiKeywords: []
 };



const setMultiKeywordChange = (state, action) => {
    
   let multiKeywords = action.payload.keywords || [];
  
    return {
        ...state,
        multiKeywords
    }
    
}
 
const ExpertMultiSearchReducer =  (state = initialState, action) => {
     switch (action.type) {
         case EXPERT_MULTI_KEYWORD_CHANGE:
            return setMultiKeywordChange(state, action);
            break;
         
        default:
           return state;
           break;
            
     }
 }



export default ExpertMultiSearchReducer;

 